import React, { useState, useEffect } from "react";
import {
    CarouselContainer,
    CarouselTitle,
    SubRow,
    SubCard,
    SubMedia,
    SubContent,
    ProductName,
    ProductBrand,
    ProductPrice,
    ProductPartNumber,
    DotsContainer,
    Dot,
} from "./BestSellerSlide.styles";
import { getProducts } from "../../api/api";

const BestSellerSlide = ({ onProductSelect }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProducts = async () => {
        try {
            const response = await getProducts("skip=0&limit=12");
            const mapped = response.map((p) => {
                // Check if price is on demand (same logic as ProductCard)
                const isPriceOnDemand = p.pricing_mode === 'ON_DEMAND' || 
                    p.current_price === null || 
                    p.current_price === undefined || 
                    p.current_price === 0;
                const price = isPriceOnDemand 
                    ? "Price on Demand" 
                    : `$${(p.current_price || 0).toFixed(2)} (VAT excl.)`;
                
                return {
                    id: p.id,
                    image:
                        p.image_urls && p.image_urls.length > 0
                        ? p.image_urls[0]
                        : "/ProductHolder.png",
                    description: p.description || p.name || p.category || "No description",
                    brand: p.brand,
                    price: price,
                    partNumber: p.sku,
                    // Store full product for ProductInfo modal
                    fullProduct: p,
                };
            });
            setProducts(mapped);
        } catch (error) {
            console.error("Failed to fetch products:", error);
        } finally {
            setLoading(false);
        }
        };

        fetchProducts();
    }, []);

    useEffect(() => {
        if (!products.length) return;
        const totalSlides = Math.ceil(products.length / 4);
        const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % totalSlides);
        }, 10000);
        return () => clearInterval(interval);
    }, [products]);

    if (loading) return <div>Loading products...</div>;
    if (!products.length) return <div>No products found.</div>;

    const startIndex = currentSlide * 4;
    const slideProducts = products.slice(startIndex, startIndex + 4);
    const totalSlides = Math.ceil(products.length / 4);

    const handleProductClick = (product) => {
        // Navigate to landing page with productId to open ProductInfo modal
        if (onProductSelect && product.id) {
            onProductSelect(product.id, product.fullProduct);
        }
    };

    return (
        <CarouselContainer>
        <CarouselTitle variant="h6">Best Sellers</CarouselTitle>

        <SubRow>
            {slideProducts.map((product, index) => (
            <SubCard
            key={index}
            onClick={() => handleProductClick(product)}
            style={{ cursor: 'pointer' }}
            >
            <SubMedia component="img" image={product.image} alt={product.description} />
            <SubContent>
            <ProductName 
                sx={{ 
                    fontSize: '0.95rem',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    minHeight: '2.4em',
                    lineHeight: '1.2em',
                }}
            >
                {product.description}
            </ProductName>
            <ProductBrand sx={{ fontSize: '0.85rem' }}>{product.brand}</ProductBrand>
            <ProductPrice sx={{ fontSize: '0.95rem' }}>{product.price}</ProductPrice>
            <ProductPartNumber sx={{ fontSize: '0.75rem' }}>
                PN: {product.partNumber}
            </ProductPartNumber>
            </SubContent>
            </SubCard>
            ))}
        </SubRow>

        <DotsContainer>
            {Array.from({ length: totalSlides }).map((_, index) => (
            <Dot
                key={index}
                active={currentSlide === index}
                onClick={() => setCurrentSlide(index)}
            />
            ))}
        </DotsContainer>
        </CarouselContainer>
    );
};

export default BestSellerSlide;
